const images = {
    ygtBackgroundImage: require('./ygtBackgroundImage.png'),
    logoYGT: require('./logo-ygt.png'),
    notFound: require('./not-found-img.svg').default,
    awardGoflLogo:  require('./award-gofl-logo.png'),
    keyIndor : require('./Key-in-door.jpg'),
    golfDefault: require('./golf_default.jpg')
}
export default images;